import { ASSETS_BASE_URL } from "../http-common";

const file_path = ASSETS_BASE_URL;

export default file_path;
